<template>
  <div>
    <div v-if="uiView == 'list'">
      <button class="btn btn-success" @click="openEditor(null)">{{$t('common.add')}}</button>
      <a v-if="lastAdded" target="_blank" :href="generateEmailLink('userCredentials', users[userIndex[lastAdded]].email, {un: users[userIndex[lastAdded]].email, pw: pwd, host: location.host})" class="btn btn-warning" >
        {{$t('users.emailToLastUser', {un: users[userIndex[lastAdded]].email})}}
      </a>
      <br/><br/>
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">{{$t('users.name')}}</th>
            <th scope="col">{{$t('login.un')}}</th>
            <th scope="col">{{$t('users.phone')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.uid">
            <td><a href="#" target="_blank" @click.prevent="openEditor(user)" :title="$t('common.update')" v-html="htmlName(user)"></a></td>
            <td><a :href="'mailto:'+user.email" target="_blank" :title="$t('login.un')" v-html="htmlSplitEmail(user.email)"></a></td>
            <td><a :href="'tel:'+user.phoneNumber" :title="$t('users.call')" v-html="htmlSplitPhoneNo(user.phoneNumber)"></a></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="uiView == 'spinner'">
      <br/><br/><br/>
      <div class="d-flex justify-content-center">
        <div class="spinner-border text-danger" role="status" style="width: 5rem; height: 5rem;">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <form v-if="uiView == 'form'">

        <div class="form-group row">
            <label for="email" class="col-sm-2 col-form-label">
              {{$t('login.un')}}
              <span v-if="'email' in formErrors" span class="badge badge-pill badge-danger">!</span>
            </label>
            <div class="col-sm-10">
                <input type="email" class="form-control" id="email" name="email" v-model="editUser.email" autocomplete="off"/>
            </div>
        </div>

        <div class="form-group row">
            <label for="displayName" class="col-sm-2 col-form-label">{{$t('users.name')}}</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="displayName" name="displayName" v-model="editUser.displayName"/>
            </div>
        </div>

        <div class="form-group row">
            <label for="phoneNumber" class="col-sm-2 col-form-label">
              {{$t('users.phone')}}
              <span v-if="'phoneNumber' in formErrors" span class="badge badge-pill badge-danger">!</span>
            </label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="phoneNumber" name="phoneNumber" v-model="editUser.phoneNumber" placeholder="+12345678..."/>
            </div>
        </div>

        <div class="form-group row">
            <label for="pwd" class="col-sm-2 col-form-label">
              {{$t('login.pw')}}
              <span v-if="'pwd' in formErrors" span class="badge badge-pill badge-danger">!</span>
            </label>
            <div class="col-sm-10">
                <input type="password" class="form-control" id="pwd" name="pwd" v-model="pwd" placeholder="A1B2C3..."  autocomplete="new-password" />
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-12">
                <input type="checkbox" id="disabled" name="disabled" v-model="editUser.disabled" />
                <label for="disabled">{{$t('users.bannd')}}</label>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-12">
                <input type="checkbox" id="claims_a" name="claims_a" v-model="editClaims['a']" />
                <label for="claims_a">{{$t('users.claims.a')}}</label>
            </div>
        </div>

        <div class="alert alert-primary"><strong>{{$t('sites.title')}}</strong></div>

        <div v-for="site in editUserSites" :key="'site_'+site.id" class="form-group row">
            <div class="col-sm-12">
                <input type="checkbox" :id="'site_'+site.id" :name="'site_'+site.id" v-model="site.val" />
                <label :for="'site_'+site.id">{{site.name}}</label>
            </div>
        </div>

        <div v-if="error !== null" class="alert alert-danger">{{error}}</div>

        <div class="form-group row">
            <div class="col-sm-2"></div>
            <div class="col-sm-10">
                <button v-if="fnLoading" class="btn btn-danger" type="button" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{$t('common.update')}}
                </button>
                <input  v-if="!fnLoading" type="button" class="btn btn-danger" @click="saveEditor" :value="$t('common.update')"/>
                <input type="button" class="btn btn-warning" @click="closeEditor" :value="$t('common.cancel')"/>
            </div>
        </div>

        <div class="form-group row" v-for="readonly in ro" :key="readonly.id">
            <div class="col-sm-2">{{readonly.n}}</div>
            <div class="col-sm-10">{{readonly.v}}</div>
        </div>

    </form>
  </div>
</template>

<script>

const mainFields = {
  email: {
    default: '',
    re: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },
  phoneNumber: {
    default: '',
    re: /^\+[0-9]{8,}$|^$/,
    ifNullValidate: ''
  },
  displayName: {
    default: '',
    ifNullValidate: ''
  },
  disabled: {
    default: false
  }
}

const roFields = {
  metadata: [
    {f: "creationTime", t: 'date'},
    {f: "lastSignInTime", t: 'date'},
    {f: "lastRefreshTime", t: 'date'}
  ]
}

import db from '@/firebase/init'
import firebase from 'firebase';
import SkVars from '../mixins/SkVars'

export default {
  name: 'Users',
  mixins: [SkVars],

  data () {
    return {
      uiView: 'spinner',
      fnLoading: false,
      users: [],
      userIndex: [],
      listView: true,
      editUser: null,
      editClaims: {},
      pwd: '',
      formErrors: {},
      ro: [],
      error: null,
      lastAdded: '',
      userSites: null,
      editUserSites: null
    }
  },

  methods: {

    htmlName(user) {
      name = user.displayName == null || user.displayName.trim() == '' ? '...' : user.displayName
      if('customClaims' in user && 'a' in user.customClaims && user.customClaims.a === 1) {
        name = '<strong>' + name + '</strong>'
      }
      if(user.disabled) { name = '<strike>' + name + '</strike>' }
      return name
    },

    htmlSplitEmail(email) {
      var l = email.length
      var c, i
      var e  = ''
      for(i = 0; i < l; i++) {
        c = email.charAt(i)
        e += (c == '@' || c == '.' ? '<wbr/>' : '') + c
      }
      return e
    },

    htmlSplitPhoneNo(phoneNumber) {
      return typeof phoneNumber === 'string'
        ? phoneNumber.substr(0, phoneNumber.length >> 1) + '<wbr/>'
          + phoneNumber.substr(phoneNumber.length >> 1)
        : ''
    },

    loadUserList() {
      this.uiView = 'spinner'
      const fnUserList = firebase.app().functions(process.env.VUE_APP_FN_HOSTING).httpsCallable('userList')
      fnUserList({}).then((users) => {
        for(var i in users.data.users) { this.userIndex[users.data.users[i].uid] = i }
        this.$set(this, 'users', users.data.users)
        if(!this.hasCurrentUserClaims('a')) { this.$router.push({name: 'Sites'}) }
        if(this.$route.params.uid) {
          let uid = this.$route.params.uid == 'me'
            ? this.currentUser.uid
            : this.$route.params.uid
          this.openEditor(this.users[this.userIndex[uid]])
        } else {
          this.uiView = 'list'
        }
      })
    },

    createEditSiteList(arr, user) {
      var sites = []
      var exists
      for(var i in arr) {
        exists = false
        if(user) {
          for(var j in arr[i].admins) {
            if(user.uid == arr[i].admins[j]) {
              exists = true
              break;
            }
          }
        }
        sites.push({
          id: arr[i].id,
          name: arr[i].name,
          val: exists,
          original: exists
        })
      }
      this.$set(this, 'editUserSites', sites)
    },

    openEditor(user) {
      var sites = []
      if(this.userSites == null) {
        db.collection("sites").get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                sites.push({
                  id: doc.id,
                  name: doc.data().name,
                  admins: doc.data().roles.admin
                })
            })
            sites.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
            this.$set(this, 'userSites', sites)
            this.createEditSiteList(sites, user)
        }).catch((error) => {
            console.error("Error getting documents: ", error);
        })
      } else {
        this.createEditSiteList(this.userSites, user)
      }
      this.lastAdded = ''
      this.$set(this, 'formErrors', {})
      this.pwd = ''
      this.ro = []
      this.editClaims = {}
      for(var i in this.CLAIMS) { this.editClaims[this.CLAIMS[i]] = 0 }
      if(user  == null) {
        var userData = {uid: null};
        for(var i in mainFields) { userData[i] = mainFields[i].default }
        this.editUser = userData
      } else {
        this.editUser = JSON.parse(JSON.stringify(user))
        if('customClaims' in user) { for(var i in user.customClaims) { this.editClaims[i] = user.customClaims[i] } }
        for(var i in roFields.metadata) {
          if(roFields.metadata[i].f in user.metadata && user.metadata[roFields.metadata[i].f]) {
            this.ro.push({
              id: user.uid + '_' + roFields.metadata[i].f,
              n: this.$t('users.metadata.' + roFields.metadata[i].f),
              v: 't' in roFields.metadata[i] && roFields.metadata[i].t == 'date'
                ? (new Date(user.metadata[roFields.metadata[i].f])).toISOString().substr(0,19).replace('T',' ')
                : user.metadata[roFields.metadata[i].f]
            })
          }
        }
      }
      this.uiView = 'form'
      return false
    },

    closeEditor() {
      this.fnLoading = false
      if(this.$route.name == 'UserEdit') {
        this.$router.push({name: 'Users'})
      } else {
        this.loadUserList()
      }
    },

    handleSiteChanges(uid, index) {
      if(index >= this.editUserSites.length) { return this.closeEditor() }
      if(this.editUserSites[index].val != this.editUserSites[index].original) {
        if(uid == firebase.auth().currentUser.uid) { this.$globalData.dSites = null }
        db.collection("sites").doc(this.editUserSites[index].id).update({
          "roles.admin": this.editUserSites[index].val 
            ? firebase.firestore.FieldValue.arrayUnion(uid)
            : firebase.firestore.FieldValue.arrayRemove(uid)})
        .then(() => {
            if(this.editUserSites[index].val) {
              this.userSites[index].admins.push(uid)
            } else {
              this.userSites[index].admins.splice(this.userSites[index].admins.indexOf(uid), 1)
            }
            return this.handleSiteChanges(uid, index+1)
        })
        .catch((error) => {
            console.error("Error updating document: ", error)
            return this.closeEditor()
        })
      }
      return this.handleSiteChanges(uid, index+1)
    },

    saveEditor() {
      this.error = null
      this.$set(this, 'formErrors', {})
      var userData = {}
      for(var i in mainFields) {
        if(this.editUser[i] != ''|| typeof this.editUser[i] == 'boolean') {
          userData[i] = this.editUser[i] || typeof this.editUser[i] == 'boolean' ? this.editUser[i] : null
        }
        if('re' in mainFields[i]) {
          var validateVal = 'ifNullValidate' in mainFields[i] && this.editUser[i] == null
            ? mainFields[i].ifNullValidate
            : this.editUser[i]
          if(!mainFields[i].re.test(validateVal)) {
            this.$set(this.formErrors, i, 1)
          }
        }
      }
      if(this.editUser.uid == null || this.pwd != '') {
        if(this.pwd.length < 6) {
          this.$set(this.formErrors, 'pwd', 1)
        } else {
          userData.password = this.pwd
        }
      }
      if(Object.keys(this.formErrors).length !== 0) {
        this.error = this.$t('users.err.formFields')
        return
      }
      this.fnLoading = true
      var customClaims = {}
      for(var i in this.editClaims) { customClaims[i] = this.editClaims[i] ? 1 : 0 }
      const fnUserModify = firebase.app().functions(process.env.VUE_APP_FN_HOSTING).httpsCallable('userModify')
      fnUserModify({uid: this.editUser.uid, user: userData, claims: customClaims}).then((result) => {
        if('error' in result.data) {
          this.fnLoading = false
          this.error = result.data.error.message == 'TOO_LONG'
            ? this.$t('users.err.g_TOO_LONG')
            : result.data.error.message
        } else {
          if(this.editUser.uid == null) { this.lastAdded = result.data.user.uid }
          this.handleSiteChanges(result.data.user.uid, 0)
        }
      }).catch((error) => {
        this.fnLoading = false
        this.error = error.message
      })
    }
  },

  created() {
    this.loadUserList()
  }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Users.vue